(function () {
    'use strict';

    const GlobalVideoController = {
        videos: new Set(),
        isPaused: false,
        initialized: false,

        register(video) {
            if (!video || !(video instanceof HTMLVideoElement)) return;
            this.videos.add(video);
            if (this.isPaused) video.pause();
            video.closest('[data-video-container]')?.setAttribute('data-video-registered', 'true');
        },

        unregister(video) {
            this.videos.delete(video);
        },

        pauseAll() {
            this.isPaused = true;
            document.documentElement.setAttribute('data-videos-paused', 'true');
            this.videos.forEach(video => { if (!video.paused) video.pause(); });
            try { sessionStorage.setItem('globalVideosPaused', 'true'); } catch (e) {}
            window.dispatchEvent(new CustomEvent('videos:paused'));
            this._announceStatus('Video paused');
            this._updateAllButtonStates(true);
        },

        playAll() {
            this.isPaused = false;
            document.documentElement.setAttribute('data-videos-paused', 'false');
            this.videos.forEach(video => {
                if (video.paused) video.play().catch(err => console.log('Video play prevented:', err.message));
            });
            try { sessionStorage.setItem('globalVideosPaused', 'false'); } catch (e) {}
            window.dispatchEvent(new CustomEvent('videos:playing'));
            this._announceStatus('Video playing');
            this._updateAllButtonStates(false);
        },

        toggleAll() {
            this.isPaused ? this.playAll() : this.pauseAll();
        },

        getPauseState() {
            return this.isPaused;
        },

        _updateAllButtonStates(isPaused) {
            document.querySelectorAll('[data-video-pause-btn]').forEach(btn => {
                btn.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
                // Swap only the Pause/Play prefix so each button keeps its
                // context-specific suffix (which video it controls)
                const current = btn.getAttribute('aria-label') || '';
                const base = current.replace(/^(Pause|Play)\s/, '');
                const newLabel = (isPaused ? 'Play ' : 'Pause ') + base;
                btn.setAttribute('aria-label', newLabel);
                const srOnly = btn.querySelector('.sr-only');
                if (srOnly) srOnly.textContent = newLabel;
            });
        },

        _announceStatus(message) {
            const region = document.getElementById('video-playback-status');
            if (!region) return;
            // Clear first so repeated toggles always re-announce
            region.textContent = '';
            requestAnimationFrame(() => { region.textContent = message; });
        },

        initClickHandlers() {
            document.addEventListener('click', (e) => {
                const pauseBtn = e.target.closest('[data-video-pause-btn]');
                if (!pauseBtn) return;
                // Section handlers call stopPropagation, so this only fires for
                // buttons without their own element-level handler.
                e.preventDefault();
                e.stopPropagation();
                this.toggleAll();
            });
        },

        init() {
            if (this.initialized) return;
            this.initialized = true;
            this.isPaused = false;
            document.documentElement.setAttribute('data-videos-paused', 'false');
            this.initClickHandlers();
        }
    };

    GlobalVideoController.init();
    window.GlobalVideoController = GlobalVideoController;
})();
